@if (isProfessionalClient) {
<div class="qualification-state qualification-state--professional">
  <div class="qualification-state__title">
    {{ "admin.common.qualificationState.professionalClient.title" | translate }}
  </div>
  <div class="qualification-state__text">
    {{ "admin.common.qualificationState.professionalClient.userMessage" | translate }}
  </div>
</div>
} @else if (isQualificationNotFilled) {
<div class="qualification-state qualification-state--not-filled">
  <div class="qualification-state__title">
    {{ "admin.common.qualificationState.notFilled.title" | translate }}
  </div>
  <div class="qualification-state__text">
    {{ "admin.common.qualificationState.notFilled.userMessage" | translate }}
  </div>
</div>
} @else {
@for (group of badgeGroups; track group.groupId; let i = $index) {
<app-decision-badge-list
  [title]="group.title"
  [items]="group.items"
  [completedAt]="group.completedAt"
>
</app-decision-badge-list>
}

<div class="iq-wrap">
  <div class="iq-header-wrapper">
    <h3 class="iq-title">
      {{
        "registrationWizard.investmentQualificationTest.knowledgeTestForm.knowledgeTest"
          | translate
      }}
    </h3>
    <hr class="sub-divider m-0" />

    <span class="sub-header--strong">
      {{ "general.income" | translate }}
    </span>

    <div class="iq-currency-row">
      <span class="sub-header--light">
        {{ "general.currency" | translate }}
      </span>
      <span class="sub-header--strong">
        {{ user?.currencyCode ?? "-" }}
      </span>
    </div>
  </div>

  <div class="iq-income-table">
    <div class="iq-income-header-row">
      <div class="iq-income-header-cell">
        {{
          "registrationWizard.investmentQualificationTest.knowledgeTestForm.netIncome"
            | translate
        }}
      </div>
      <div class="iq-income-header-cell iq-income-header-cell--right">
        {{
          "registrationWizard.investmentQualificationTest.knowledgeTestForm.regularIncome"
            | translate
        }}
      </div>
    </div>

    @if (incomeRows.length) { @for (row of incomeRows; track row.id) {
    <div class="iq-income-row">
      <div class="iq-income-cell">
        {{ formatCurrency(row.netIncome) }}
      </div>
      <div class="iq-income-cell iq-income-cell--right">
        <span
          class="badge"
          [ngClass]="boolBadge.badgeClass(boolToKey(row.regularIncome))"
        >
          {{ boolBadge.labelKey(boolToKey(row.regularIncome)) ?? "" | translate }}
        </span>
      </div>
    </div>
    } } @else {
    <div class="iq-income-row">
      <div class="iq-income-cell">
        {{ "general.noContent" | translate }}
      </div>
      <div class="iq-income-cell iq-income-cell--right">-</div>
    </div>
    }
  </div>

  <div class="iq-summary-list">
    <div class="kv-line">
      <span class="kv-label">
        {{
          "registrationWizard.investmentQualificationTest.knowledgeTestForm.totalIncomeInAMonth"
            | translate
        }}
      </span>
      <span class="kv-value">
        {{ formatCurrency(user?.notQualifiedUserIncomeSum ?? null) }}
      </span>
    </div>
    <div class="kv-line">
      <span class="kv-label">
        {{
          "registrationWizard.investmentQualificationTest.knowledgeTestForm.availableFounds"
            | translate
        }}
      </span>
      <span class="kv-value">
        {{
          formatCurrency(user?.notQualifiedUserIncomes?.availableMoneyAssetsValue ?? null)
        }}
      </span>
    </div>
    <div class="kv-line">
      <span class="kv-label">
        {{
          "registrationWizard.investmentQualificationTest.knowledgeTestForm.financialCommitmentsValue"
            | translate
        }}
      </span>
      <span class="kv-value">
        {{
          formatCurrency(user?.notQualifiedUserIncomes?.financialCommitmentsValue ?? null)
        }}
      </span>
    </div>
    <div class="kv-line">
      <span class="kv-label">
        {{
          "registrationWizard.investmentQualificationTest.knowledgeTestForm.currentNetWealth"
            | translate
        }}
      </span>
      <span class="kv-value">
        {{ formatCurrency(user?.notQualifiedUserNetWorth ?? null) }}
      </span>
    </div>
    <div class="kv-line kv-line--strong">
      <span class="kv-label">
        {{
          "registrationWizard.investmentQualificationTest.knowledgeTestForm.netWealthAfterLoss"
            | translate
        }}
      </span>
      <span class="kv-value">
        {{ formatCurrency(netWealthAfterLoss ?? null) }}
      </span>
    </div>
  </div>
</div>
}
